// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__9pRrw","row":"styles_row__2LUTi"};